import { authSplitApi } from 'redux/helpers/slice.helpers';
import { materialOptionConverter } from 'data/convertors/General.converters';
import {
  TMultiOptionTypeMaterialUI,
  TOptionType,
} from 'data/types/GeneralTypes';
import { EAnimalUrls } from 'data/urls/animal.url';
import {
  TAnimalBreedDB,
  TAnimalBreedUI,
  TAnimalColorsDB,
  TAnimalColorsUI,
} from 'data/types/Animal.types';
import {
  animalBreedConvertor,
  animalColorConvertor,
} from 'data/convertors/Animal.converters';

export const generalApi = authSplitApi(
  'generalApi',
  ['species', 'breeds', 'animal-colors'],
  'tenant',
).injectEndpoints({
  endpoints: build => ({
    getSpecies: build.query<TMultiOptionTypeMaterialUI[], void>({
      query() {
        return {
          url: `/${EAnimalUrls.ANIMALS}/${EAnimalUrls.SPECIES}`,
          method: 'GET',
        };
      },
      transformResponse: (data: TOptionType[]) =>
        (data || []).map(item => materialOptionConverter.fromDb(item)),
      providesTags: ['species'], // for caching and update cache
    }),

    getAnimalBreed: build.query<TAnimalBreedUI[], { speciesId: string }>({
      query(params) {
        return {
          url: `/${EAnimalUrls.ANIMALS}/breeds`,
          method: 'GET',
          params,
        };
      },
      transformResponse: (data: TAnimalBreedDB[]) => {
        return data.map(item => animalBreedConvertor.fromDb(item));
      },
      providesTags: ['breeds'],
    }),

    getAnimalColors: build.query<TAnimalColorsUI[], void>({
      query() {
        return {
          url: `${EAnimalUrls.ANIMALS}/colors`,
          method: 'GET',
        };
      },
      transformResponse: (data: TAnimalColorsDB[]) => {
        return data.map(item => animalColorConvertor.fromDb(item));
      },
      providesTags: ['animal-colors'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSpeciesQuery,
  useGetAnimalBreedQuery,
  useGetAnimalColorsQuery,
} = generalApi;
